import styled from '@emotion/styled'
import {
  DataValueLabel,
  DataVariableLabel,
} from '../../../../ui_reusable/styles/DataInfoUtils.styles'

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4rem;
  padding: 1rem;
`

export const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`

export const InfoSection = styled.div`
  width: 60%;
`

export const LogoSection = styled.div`
  width: 40%;
  max-width: 500px;
`

export const EditableFieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`

export const Cell = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export const NormalCell = styled(Cell)`
  height: 2rem;
  display: flex;
  align-items: center;
`

export const ShrankCell = styled(Cell)`
  height: 1.5rem;
  display: flex;
  align-items: top;
`

export const ClientSettingsGrid = styled.div`
  ${DataValueLabel}
  margin-top: 1rem;
  display: grid;
  grid-template-columns:
    minmax(auto, max-content) minmax(auto, max-content)
    1fr minmax(auto, max-content) minmax(auto, max-content);
  grid-template-rows: repeat(5, minmax(auto, max-content));
  align-items: stretch;
  width: 100%;
  margin-right: 1rem;

  /* Column styles */
  & > :nth-child(5n + 1) {
    ${DataVariableLabel}
    justify-self: start;
    padding-right: 1rem;
  }

  & > :nth-child(5n + 4) {
    ${DataVariableLabel}
    justify-self: start;
    padding-right: 1rem;
  }

  /* Row spacing */
  & > :nth-child(n + 26) {
    margin-top: 3rem;
  }
`
